export default __webpack_public_path__ + "static/media/dish-background-2.zip.8b4f85d6.png";